<template>
  <!-- Go to top button -->
  <button
    class="btn btn-outline-warning"
    @click="toTop()"
    id="toTopBtn"
    title="Go to top"
  >
    <i class="bi bi-arrow-90deg-up"></i>
  </button>
</template>

<script>
export default {
  name: "ScrollToTop",

  mounted() {
    // Get the button:
    let mybutton = document.getElementById("toTopBtn");

    // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = function () {
      scrollFunction();
    };

    function scrollFunction() {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    }
  },

  methods: {
    // When the user clicks on the button, scroll to the top of the document
    toTop() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
  },
};
</script>

<style scoped>
#toTopBtn {
  display: none; /* Hidden by default */
  position: fixed; /* Fixed/sticky position */
  bottom: 9px; /* Place the button at the bottom of the page */
  right: 19px; /* Place the button 30px from the right */
  z-index: 99; /* Make sure it does not overlap */
  outline: none; /* Remove outline */
  cursor: pointer; /* Add a mouse pointer on hover */
}
</style>
